import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Tooltip,
} from '@mui/material'
import { StyledTableRow } from '../styled/TableComponents'
import { formatTimestamp } from '../../../utils/dateUtils'
import { getActivityIcon } from '../../../utils/activityUtils'

const ActivityTable = ({ activities, loading, searchTerm, typeFilter }) => {
  const decodePath = (path) => {
    if (!path) return '-'
    try {
      return decodeURIComponent(path)
    } catch (error) {
      console.warn('Failed to decode path:', path, error)
      return path // Return original if decoding fails
    }
  }
  if (loading) {
    return (
      <TableContainer component={Paper} sx={{ boxShadow: 1, borderRadius: 2 }}>
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant='body2' color='text.secondary'>
            Loading activities...
          </Typography>
        </Box>
      </TableContainer>
    )
  }

  return (
    <TableContainer component={Paper} sx={{ boxShadow: 1, borderRadius: 2 }}>
      <Table>
        <TableHead sx={{ bgcolor: '#f8fafc' }}>
          <TableRow>
            <TableCell sx={{ fontWeight: 600 }}>Type</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>User</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Path</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Timestamp</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {activities.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} align='center'>
                <Typography
                  variant='body2'
                  color='text.secondary'
                  sx={{ py: 3 }}
                >
                  {searchTerm || typeFilter !== 'all'
                    ? 'No activity matches your filters'
                    : 'No recent activity'}
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            activities.map((activity) => {
              const decodedPath = decodePath(activity.path)
              return (
                <StyledTableRow key={activity.id}>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {getActivityIcon(activity.type)}
                      <Typography variant='body2'>{activity.type}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Typography variant='body2'>
                      {activity.userEmail}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Tooltip title={decodedPath} placement='top' arrow>
                      <Typography
                        variant='body2'
                        sx={{
                          maxWidth: '400px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          cursor: 'pointer',
                        }}
                      >
                        {decodedPath}
                      </Typography>
                    </Tooltip>
                  </TableCell>
                  <TableCell>
                    <Typography variant='body2'>
                      {formatTimestamp(activity.timestamp)}
                    </Typography>
                  </TableCell>
                </StyledTableRow>
              )
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default ActivityTable
